import { render, staticRenderFns } from "./modal-header.component.vue?vue&type=template&id=5124f402"
import script from "./modal-header.component.vue?vue&type=script&lang=js"
export * from "./modal-header.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports